import * as z from 'zod';
import { passwordSchema } from './PasswordValidationSchema';

const LoginZodSchema = z.object({
  login: z
    .string({ required_error: 'Login jest wymagany' })
    .min(1, 'Login jest wymagany')
    .max(64, 'Login jest zbyt długi'),
  password: passwordSchema,
});

export default LoginZodSchema;
